<template>
  <div>
    <!-- Header Section -->
    <div class="mt-5 d-flex flex-column flex-md-row align-items-start">
      <h4
        :style="testProductDetail ? 'font-size: 20px !important;' : 'font-size: 26px;'"
        class="me-2 mb-2 mb-md-0"
      >
        <span class="text-red">{{ testProductDetail ? 'Stap 2/3' : 'Stap 3/4' }}</span> - WIL JE EEN KAARTJE MEESTUREN?
      </h4>
      <p class="mb-0 ms-md-auto" style="color: #A29A90;">(max 1 kaart)</p>
    </div>
    <p class="mt-3">
      Kies je gratis kaartje en maak jouw brownie box compleet met een gepersonaliseerde boodschap voor jouw ontvanger(s).
    </p>

    <!-- Card Selectors Section -->
    <div class="row mt-4">
      <div class="col-12 col-md-6 d-flex flex-row gap-2 align-items-center w-100">
        <!-- Ja Graag Selector -->
        <div
          role="button"
          :class="`sd-card-selector d-flex flex-column align-items-center justify-content-center p-3 rounded-3 me-md-3 blue ${
            wantCard ? 'active' : ''
          }`"
          @click="pickCardYes"
        >
          <svg
            v-if="!wantCard"
            id="Group_2185"
            class="mb-3"
            xmlns="http://www.w3.org/2000/svg"
            width="45.957"
            height="34.981"
            viewBox="0 0 45.957 34.981"
          >
            <!-- SVG Path -->
            <path
              d="M45.726,3.325A4.784,4.784,0,0,0,40.88.006q-15.072,0-30.146,0C8.791.005,6.847-.01,4.9.01A4.736,4.736,0,0,0,.009,4.777q-.02,12.72.013,25.44a4.812,4.812,0,0,0,.427,1.946,4.661,4.661,0,0,0,4.6,2.817q16.443-.006,32.887,0c1.137,0,2.273.014,3.409-.011a4.613,4.613,0,0,0,3.368-1.543,5.425,5.425,0,0,0,1.248-2.581V4.185c-.076-.287-.14-.578-.231-.86m-44.3,18.9q0-8.615,0-17.231A3.345,3.345,0,0,1,4.987,1.419q2.624,0,5.25,0h.468V17.575a3.75,3.75,0,0,0-5.57-.555c-1.642,1.566-1.489,3.624.471,5.691H1.427Zm9.068.191c-1.161-.22-2.234-.408-3.3-.628a2.2,2.2,0,0,1-1.791-2.212,2.247,2.247,0,0,1,1.875-2.1,2.186,2.186,0,0,1,2.513,1.543c.283,1.094.462,2.215.7,3.4m.213,11.143h-.465c-1.749,0-3.5.005-5.247,0a3.331,3.331,0,0,1-3.568-3.594c0-1.912,0-3.824,0-5.775H9.7c-.824.822-1.584,1.578-2.344,2.337-.328.328-.666.645-.976.988a.685.685,0,0,0,0,.97.694.694,0,0,0,.97.033,4.065,4.065,0,0,0,.325-.309q1.332-1.331,2.665-2.663c.1-.1.209-.192.364-.334ZM12.187,1.441c.142-.007.3-.021.455-.021q14.175,0,28.352,0a3.332,3.332,0,0,1,3.538,3.5q.008,8.68,0,17.361v.429H17.215a3.7,3.7,0,0,0,1.665-3.139,3.524,3.524,0,0,0-1.1-2.519,3.744,3.744,0,0,0-5.593.5Zm3.481,20.347c-1.037.217-2.081.4-3.122.6a.539.539,0,0,1-.139-.029c.209-1.074.394-2.134.624-3.182a2.253,2.253,0,0,1,4.438.372,2.191,2.191,0,0,1-1.8,2.241m28.864,8.265a3.3,3.3,0,0,1-3.482,3.5q-14.245.011-28.492,0c-.118,0-.236-.012-.384-.021V25.163c.725.728,1.376,1.385,2.029,2.04.792.794,1.571,1.6,2.39,2.368a1.011,1.011,0,0,0,.752.237.715.715,0,0,0,.476-.5,1.162,1.162,0,0,0-.3-.777C16.223,27.2,14.9,25.9,13.592,24.587c-.114-.114-.223-.234-.384-.4h31.3c.009.137.025.266.025.4,0,1.825.006,3.649,0,5.474"
              fill="#ff4a4a"
            />
          </svg>
          <svg
            v-else
            class="mb-3"
            id="Group_2185"
            xmlns="http://www.w3.org/2000/svg"
            width="45.957"
            height="34.981"
            viewBox="0 0 45.957 34.981"
          >
            <!-- SVG Path -->
            <path
              d="M45.726,3.325A4.784,4.784,0,0,0,40.88.006q-15.072,0-30.146,0C8.791.005,6.847-.01,4.9.01A4.736,4.736,0,0,0,.009,4.777q-.02,12.72.013,25.44a4.812,4.812,0,0,0,.427,1.946,4.661,4.661,0,0,0,4.6,2.817q16.443-.006,32.887,0c1.137,0,2.273.014,3.409-.011a4.613,4.613,0,0,0,3.368-1.543,5.425,5.425,0,0,0,1.248-2.581V4.185c-.076-.287-.14-.578-.231-.86m-44.3,18.9q0-8.615,0-17.231A3.345,3.345,0,0,1,4.987,1.419q2.624,0,5.25,0h.468V17.575a3.75,3.75,0,0,0-5.57-.555c-1.642,1.566-1.489,3.624.471,5.691H1.427Zm9.068.191c-1.161-.22-2.234-.408-3.3-.628a2.2,2.2,0,0,1-1.791-2.212,2.247,2.247,0,0,1,1.875-2.1,2.186,2.186,0,0,1,2.513,1.543c.283,1.094.462,2.215.7,3.4m.213,11.143h-.465c-1.749,0-3.5.005-5.247,0a3.331,3.331,0,0,1-3.568-3.594c0-1.912,0-3.824,0-5.775H9.7c-.824.822-1.584,1.578-2.344,2.337-.328.328-.666.645-.976.988a.685.685,0,0,0,0,.97.694.694,0,0,0,.97.033,4.065,4.065,0,0,0,.325-.309q1.332-1.331,2.665-2.663c.1-.1.209-.192.364-.334ZM12.187,1.441c.142-.007.3-.021.455-.021q14.175,0,28.352,0a3.332,3.332,0,0,1,3.538,3.5q.008,8.68,0,17.361v.429H17.215a3.7,3.7,0,0,0,1.665-3.139,3.524,3.524,0,0,0-1.1-2.519,3.744,3.744,0,0,0-5.593.5Zm3.481,20.347c-1.037.217-2.081.4-3.122.6a.539.539,0,0,1-.139-.029c.209-1.074.394-2.134.624-3.182a2.253,2.253,0,0,1,4.438.372,2.191,2.191,0,0,1-1.8,2.241m28.864,8.265a3.3,3.3,0,0,1-3.482,3.5q-14.245.011-28.492,0c-.118,0-.236-.012-.384-.021V25.163c.725.728,1.376,1.385,2.029,2.04.792.794,1.571,1.6,2.39,2.368a1.011,1.011,0,0,0,.752.237.715.715,0,0,0,.476-.5,1.162,1.162,0,0,0-.3-.777C16.223,27.2,14.9,25.9,13.592,24.587c-.114-.114-.223-.234-.384-.4h31.3c.009.137.025.266.025.4,0,1.825.006,3.649,0,5.474"
              fill="#fff"
            />
          </svg>
          <h4
            style="font-size: 21px !important;"
            :class="`fw-bold ${wantCard ? 'text-white' : 'text-darkblue'}`"
          >
            JA GRAAG
          </h4>
        </div>

        <!-- Nee Dankjewel Selector -->
        <div
          role="button"
          :class="`sd-card-selector d-flex flex-column align-items-center justify-content-center py-3 px-2 rounded-3 ${
            !wantCard ? 'active' : ''
          }`"
          @click="pickCardNo"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34.981"
            height="34.981"
            viewBox="0 0 24 24"
            fill="none"
            :stroke="`${wantCard ? '#FF4A4A' : '#fff'}`"
            stroke-width="1"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="icon mb-3 icon-tabler icons-tabler-outline icon-tabler-forbid"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
            <path d="M9 9l6 6" />
          </svg>
          <h4
            style="font-size: 21px !important;"
            :class="`fw-bold text-center ${!wantCard ? 'text-white' : 'text-darkblue'}`"
          >
            NEE DANKJEWEL
          </h4>
        </div>
      </div>

      <!-- Scroll Offset for Layout Stability -->
      <div class="col-12">
        <div class="scrollOffset" ref="pickCardRef"></div>
      </div>

      <!-- Conditional Card Selection Content -->
      <div v-if="wantCard" class="col-12 mt-0">
        <!-- If No Card Selected -->
        <div v-if="!selectedCard" class="mt-4 mb-3">
          <h4 :style="testProductDetail ? 'font-size: 20px !important;' : 'font-size: 26px;'" class="me-2 mb-0">
            Kies een kaartje
          </h4>
          <p v-if="cardError" class="text-danger card-danger">* Selecteer een kaartje om door te gaan.</p>
          <div class="row sd-cart-grid mt-3 ms-0">
            <div
              class="col-6 col-sm-4 col-md-3 col-lg-2 p-0"
              v-for="(card, index) in cards"
              :key="index"
              @click="selectCard(card)"
            >
              <div class="sd-cart-container">
                <img :src="card.image" :alt="'card-' + card.id" class="img-fluid">
              </div>
            </div>
          </div>
        </div>

        <!-- If Card Selected -->
        <div v-else class="mt-4">
          <div v-if="showPreviousCardTextButton" class="d-flex justify-content-end mb-2">
            <button
              type="button"
              class="previous-text-btn"
              @click="applyPreviousCardText"
            >
              Gebruik de vorige tekst
            </button>
          </div>
          <div class="card-message-container shadow-sm p-3 position-relative">
            <div class="card-message-content d-flex justify-content-between align-items-start mb-4 position-absolute">
              <div class="card-preview" @click="togglePreview">
                <img :src="selectedCard.image" alt="Selected Card" class="preview-image rounded-circle">
              </div>
            </div>
            <textarea
              class="w-100 custom-textarea"
              :placeholder="getPlaceholder()"
              rows="10"
              v-model="cardtext"
              maxlength="200"
              @input="filterEmojis"
            ></textarea>
            <p class="mb-0 text-end fs-14 position-absolute end-0 mb-5 me-5 bottom-0">
              (Nog maximaal {{ 200 - cardtext.length }} letters)
            </p>
          </div>
          <div class="d-flex justify-content-between align-items-center mt-3">
            <button
              @click="deselectCard"
              class="bg-red fs-15 text-light py-2 px-4 border-0 rounded-pill me-auto"
            >
              Kies een andere kaart
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Preview Modal -->
    <div v-if="showPreview" class="preview-modal" @click="togglePreview">
      <div class="preview-content">
        <img :src="selectedCard.image" alt="Card Preview" class="full-size-image">
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, defineProps, nextTick, defineEmits, computed } from 'vue';

const props = defineProps({
  boxdata: {
    type: Object,
    required: true,
  },
  testProductDetail: {
    type: Boolean,
    default: false,
  },
  cards: {
    type: Array,
    default: () => [],
  },
  previousCardText: {
    type: String,
    default: '',
  },
  isEditing: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['pickcard', 'cardtext', 'cardname', 'validate-box', 'validate-flavor', 'card-error', 'update:wantCard', 'update:selectedCard']);
const wantCard = ref(props.boxdata.wantCard);
const cardtext = ref('');
const emojiRegex = /(\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
const selectedCard = ref(props.boxdata.selectedCard);
const showPreview = ref(false);
const cardError = ref(false);

const pickCardRef = ref(null);
const showPreviousCardTextButton = computed(() => {
  return (
    props.previousCardText &&
    props.previousCardText.trim().length > 0 &&
    !props.isEditing &&
    (!cardtext.value || cardtext.value.trim().length === 0)
  );
});

const pickCardYes = () => {
  wantCard.value = true;
  cardError.value = false;
  emitPickCard({ id: null });
  emit('cardname', ''); 
  emit('update:wantCard', true); 
};

const pickCardNo = () => {
  wantCard.value = false;
  selectedCard.value = null;
  cardtext.value = '';
  cardError.value = false;
  emitPickCard({ id: false });
  emit('cardname', ''); 
  emit('update:wantCard', false);
};

const emitPickCard = (card) => {
  emit('pickcard', card);
};

const selectCard = (card) => {
  selectedCard.value = card;
  cardError.value = false;
  emitPickCard(card);
  emit('cardname', card.name);
  emit('update:selectedCard', card);
};

const deselectCard = () => {
  selectedCard.value = null;
  emitPickCard({ id: null });
  emit('cardname', ''); // Reset card name
};

const togglePreview = () => {
  showPreview.value = !showPreview.value;
};

const applyPreviousCardText = () => {
  if (!showPreviousCardTextButton.value) {
    return;
  }
  cardtext.value = props.previousCardText;
};

const getPlaceholder = () => {
  return "Schrijf hier jouw persoonlijke boodschap op het kaartje, dan schrijven wij 'm voor je over! Vergeet ook niet je naam te vermelden zodat de ontvanger weet van wie het lekkers afkomstig is. Omdat we de kaarten met de hand schrijven is het niet mogelijk om emoji's toe te voegen.";
};

const filterEmojis = () => {
  cardtext.value = cardtext.value.replace(emojiRegex, '');
};

const validateCardSelection = () => {
  if (wantCard.value && !selectedCard.value) {
    cardError.value = true;
    emit('card-error', true); // Emit card error event
    nextTick(() => {
      const cardErrorElement = document.querySelector('.flavor-danger');
      if (cardErrorElement && !props.testProductDetail) {
        cardErrorElement.scrollIntoView({ behavior: 'smooth' });
      } else {
        const kiesEenKaartjeElement = document.querySelector('.mt-4.mb-3');
        if (kiesEenKaartjeElement && !props.testProductDetail) {
          kiesEenKaartjeElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
    return false;
  }
  cardError.value = false;
  emit('card-error', false); 
  return true;
};

watch(
  () => props.boxdata.card,
  (newCard) => {
    cardtext.value = newCard.text !== undefined ? newCard.text : '';
    const hasCardSelection = newCard.id !== false && newCard.id !== undefined && newCard.id !== null;
    wantCard.value = hasCardSelection ? true : props.boxdata.wantCard;

    if (hasCardSelection) {
      const foundCard = props.cards.find((card) => card.id === newCard.id);
      if (foundCard) {
        selectedCard.value = foundCard;
        emit('cardname', foundCard.name); 
      } else {
        selectedCard.value = null;
        emit('cardname', '');
      }
    } else {
      selectedCard.value = null;
      emit('cardname', '');
    }
    validateCardSelection();
  },
  { deep: true }
);

watch(
  () => props.boxdata.card.id,
  (newVal) => {
    if (newVal != null) {
      nextTick(() => {
        if (pickCardRef.value && !props.testProductDetail) {
          pickCardRef.value.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  },
  { immediate: true }
);

watch(cardtext, (newText) => {
  localStorage.previouscardtext = newText;
  emit('cardtext', newText);
});

watch(
  () => props.boxdata.wantCard,
  (newVal) => {
    wantCard.value = newVal;
  }
);

watch(
  () => props.boxdata.selectedCard,
  (newSelectedCard) => {
    selectedCard.value = newSelectedCard ?? null;
  },
  { deep: true }
);

onMounted(() => {
  wantCard.value = props.boxdata.wantCard;
  cardtext.value = props.boxdata.card?.text ?? '';
  validateCardSelection();
});
</script>

<style scoped>
.text-red {
  color: #ff4a4a;
}
.text-darkblue {
  color: #395AD4;
}

.sd-card-selector {
  height: 150px;
  width: 100%;
  max-width: 230px;
  background-color: white;
  border: 2px solid white;
  transition: 0.3s ease;
  cursor: pointer;
}

.sd-card-selector.active {
  background-color: #ff4a4a;
  border: 2px solid #ff4a4a;
}

.sd-card-selector.active.blue {
  background-color: #395ad4;
  border: 2px solid #395ad4;
}

.sd-card-selector.blue:hover {
  border: 2px solid #395AD4;
}

.sd-card-selector:hover {
  border: 2px solid #FF4A4A;
}

.sd-cart-container {
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  border: 2px solid #fff1e3;
  transition: all 0.3s;
}

.sd-cart-container:hover {
  border: 2px solid #ff4a4a;
}

.sd-cart-container > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Card Message Container Styling */
.card-message-container {
  background-color: #e4dcd1;
  border-radius: 15px;
  position: relative;
  padding-top: 120px;
}

.card-preview {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 20px;
  left: 15px;
  cursor: pointer;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

/* Textarea Styling */
textarea {
  border-radius: 8px;
  padding: 25px;
  width: 100%;
  resize: vertical;
  background-color: #fff !important;
  border: 0;
  outline: none;
  height: 420px;
  padding-left: 140px;
  line-height: 2;
  font-size: 18px;
}

.previous-text-btn {
  border: none;
  background: transparent;
  color: #395ad4;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  font-size: 15px;
}

.previous-text-btn:hover {
  color: #ff4a4a;
}

.previous-text-btn:focus {
  outline: none;
}

.custom-textarea {
  padding-right: 15px;
  resize: none;
}

/* Responsive Adjustments */
@media (max-width: 767.98px) {
  .d-flex.flex-column.flex-md-row {
    flex-direction: column !important;
  }

  .mb-md-0 {
    margin-bottom: 1rem !important;
  }

  .ms-md-auto {
    margin-left: 0 !important;
  }

  .sd-card-selector {
    max-width: none;
    width: 100%;
  }

  .sd-cart-grid .col-lg-2 {
    max-width: 50%;
    flex: 0 0 50%;
  }

  textarea {
    height: 200px;
    padding-left: 25px;
  }

  .card-message-container {
    padding-top: 80px;
  }

  .card-preview {
    width: 80px;
    height: 80px;
    top: 20px;
    display: block !important;
    left: 10px;
  }

  /* Preview Modal Adjustment */
  .preview-content {
    max-width: 90%;
    max-height: 90%;
  }

  .full-size-image {
    width: 100%;
    height: auto;
    object-fit: contain;
  }

  .sd-cart-grid .col-sm-4 {
    max-width: 50%;
    flex: 0 0 50%;
  }
}

.scrollOffset {
  height: 20px;
  visibility: hidden;
  margin-top: -110px;
  position: absolute;
}

.preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.preview-content {
  max-width: 600px;
  max-height: 90%;
}

.full-size-image {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.sd-cart-container:hover {
  opacity: 0.8;
}

.sd-cart-container.active {
  opacity: 1;
}

.card-message-container textarea {
  padding-left: 140px;
}

/* Ensure buttons are responsive */
.bg-red {
  background-color: #ff4a4a !important;
}

.text-light {
  color: #fff !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.fs-15 {
  font-size: 15px !important;
}

.fs-14 {
  font-size: 14px !important;
}

.card-danger {
  margin-top: 1rem;
}

@media (max-width: 1200px) {
  textarea {
  font-size: 14px;
  padding-left: 15px !important;
}

.card-message-container div {
  display: none;
}
}

@media (max-width: 992px) {
  textarea {
  font-size: 14px;
  padding-left: 140px !important;
  min-height: 300px;
}

.card-message-container div {
  display: block;
}
}

@media (max-width: 520px) {
  textarea {
  font-size: 14px;
  padding-left: 15px !important;
}

.card-message-container div {
  display: none;
}

.card-preview,
.card-message-content {
  position: relative !important;
}

.card-preview {
  top: 0px;
  background-color: #fff;
  border-radius: 100%;
}

.card-message-content {
  margin-bottom: 10px !important;
}
}



</style>
